export default __webpack_public_path__ + "static/media/wrLogo.06b08027.png";